export default "__VITE_ASSET__d999c2d3__"